var __jsx = React.createElement;
import Head from 'next/head';
import { useRouter } from 'next/router';
import React from 'react';
import { isProductionEnv } from "../../utils/EnvUtils";
const DixuHead = _ref => {
  let {
    root,
    titleAffix,
    titleAffixPosition,
    title,
    description,
    image,
    url,
    type,
    author,
    siteName,
    keywords,
    children
  } = _ref;
  const router = useRouter();
  const {
    asPath,
    pathname
  } = router || {};
  const defaultURL = `${process.env.WEB_URL}${asPath}`;
  const renderedTitle = (() => {
    if (titleAffixPosition === 'end') {
      return [title, title && titleAffix && ' | ', titleAffix].filter(Boolean).join('').trim();
    }
    return [titleAffix, titleAffix && title && ' − ', title].filter(Boolean).join('').trim();
  })();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Head, null, root && /*#__PURE__*/React.createElement(React.Fragment, null, isProductionEnv && pathname === '/' && /*#__PURE__*/React.createElement("meta", {
    key: "facebook-domain-verification",
    name: "facebook-domain-verification",
    content: "ffgzyjn403wpgr2dn3zcjwxf38jo8j"
  })), renderedTitle && /*#__PURE__*/React.createElement("title", {
    key: "title"
  }, renderedTitle), renderedTitle && /*#__PURE__*/React.createElement("meta", {
    key: "og:title",
    property: "og:title",
    content: renderedTitle
  }), description && /*#__PURE__*/React.createElement("meta", {
    key: "description",
    name: "description",
    content: description
  }), description && /*#__PURE__*/React.createElement("meta", {
    key: "og:description",
    property: "og:description",
    content: description
  }), image && /*#__PURE__*/React.createElement("meta", {
    key: "og:image",
    property: "og:image",
    content: image
  }), type && /*#__PURE__*/React.createElement("meta", {
    key: "og:type",
    property: "og:type",
    content: type
  }), author && /*#__PURE__*/React.createElement("meta", {
    key: "author",
    name: "author",
    content: author
  }), siteName && /*#__PURE__*/React.createElement("meta", {
    key: "og:site_name",
    property: "og:site_name",
    content: siteName
  }), keywords && /*#__PURE__*/React.createElement("meta", {
    key: "keywords",
    name: "keywords",
    content: keywords
  }), /*#__PURE__*/React.createElement("meta", {
    key: "og:url",
    property: "og:url",
    content: url || defaultURL
  }), /*#__PURE__*/React.createElement("meta", {
    key: "og:locale",
    property: "og:locale",
    content: "fi"
  }), children));
};
DixuHead.defaultProps = {
  root: false,
  titleAffix: 'Dixu',
  titleAffixPosition: 'start',
  title: undefined,
  description: undefined,
  image: undefined,
  url: undefined,
  type: 'website',
  author: 'Dixu',
  siteName: 'Palvelualusta, joka yhdistää myyjän, ostajan ja välittäjän.',
  keywords: 'Dixu, Diksu, Asunnon myynti, Myy asuntosi, Itsemyynti, Myytävät asunnot, Asunto, Asunnot, Dixu.fi'
};
export default DixuHead;